/**
 * ChannelLogoPair Component
 * Now uses actual component code in the module
 */

export { default } from './ChannelLogoPair';
